import React, { useState } from "react";
import { Tab, Button } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import { useAuth } from "../../../../hooks";
import {
  InstitutionForm,
  InstitutionList,
} from "../../../../components/Admin/RoleNewUser/InstitutionCmp";
import "./Page_Partner_Institution.scss";

export function Page_Partner_Institution() {
  const { user } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const panes = [
    {
      menuItem: "Instituciones activas",
      render: () => (
        <Tab.Pane attached={false}>
          <InstitutionList
            institutionActive={true}
            reload={reload}
            onReload={onReload}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Instituciones inactivas",
      render: () => (
        <Tab.Pane attached={false}>
          <InstitutionList
            institutionActive={false}
            reload={reload}
            onReload={onReload}
          />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="register-page">
        <Button className="users-page__add" primary onClick={onOpenCloseModal}>
          Nueva Institución
        </Button>
        <Tab menu={{ secondary: true }} panes={panes} />
      </div>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Crea nuevo usuario"
      >
        <InstitutionForm
          user={user}
          close={onOpenCloseModal}
          onReload={onReload}
        />
      </BasicModal>
    </>
  );
}
